import { render, staticRenderFns } from "./RecentlyHotTravelGroupForm.vue?vue&type=template&id=26673d89&"
import script from "./RecentlyHotTravelGroupForm.vue?vue&type=script&lang=js&"
export * from "./RecentlyHotTravelGroupForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports